import SignaturePad from 'signature_pad';
import { SignatureFormat } from '../signature-types';
import { createCanvas, createCanvasFromDataUrl, getCroppedCanvas, getScaledCanvas } from './canvas';
import { MAX_HEIGHT } from './constants';
import { decodePoints } from './points';
import { writeTextOnCanvas } from './text';
const DATA_URI_REGEX = /^data:([^;,]+)(?:;([^,]+))?,(.+)$/;
export function isDataUrl(dataUrl) {
  return DATA_URI_REGEX.test(dataUrl);
}
export function decodeDataUrl(dataUrl) {
  if (!dataUrl) {
    return undefined;
  }
  const match = dataUrl.match(DATA_URI_REGEX);
  if (!match) {
    return undefined;
  }
  const [, mimeType, encoding, data] = match;
  return {
    data: encoding === 'base64' ? atob(data) : decodeURI(data),
    mimeType,
    encoding: encoding
  };
}
export function encodeDataUrl(_ref) {
  let {
    data,
    mimeType,
    encoding = 'text'
  } = _ref;
  const encodedData = encoding === 'base64' ? btoa(data) : encodeURI(data);
  const typeAndEncoding = encoding === 'base64' ? `${mimeType};base64` : mimeType;
  return `data:${typeAndEncoding},${encodedData}`;
}
export function dataUrlToFile(dataUrl, filename) {
  const decoded = decodeDataUrl(dataUrl);
  if (!decoded) {
    return undefined;
  }
  let n = decoded.data.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = decoded.data.charCodeAt(n);
  }
  const extension = decoded.mimeType.split('/')[1] ?? 'txt';
  return new File([u8arr], `${filename}.${extension}`, {
    type: decoded.mimeType
  });
}
export function dataUrlToWixFile(url, displayName) {
  if (displayName === void 0) {
    displayName = 'temp';
  }
  const decoded = decodeDataUrl(url);
  return {
    fileId: 'temp',
    displayName,
    url,
    fileType: (decoded == null ? void 0 : decoded.mimeType) ?? ''
  };
}
export async function dataUrlToPngDataUrl(dataUrl, rtl) {
  const decodedDataUrl = decodeDataUrl(dataUrl);
  if (!decodedDataUrl) {
    return dataUrl;
  }
  const dataUrlType = decodedDataUrl.mimeType;
  if (dataUrlType === SignatureFormat.TEXT) {
    // Width doesn't matter, it will be cropped later
    const canvas = createCanvas(MAX_HEIGHT * 20, MAX_HEIGHT, 1);
    writeTextOnCanvas(canvas, decodedDataUrl.data, 'black', rtl, 'white');
    const croppedCanvas = getCroppedCanvas(canvas, 'white');
    // When cropped canvas is null it means we have an empty image ( example a transparent background )
    return (croppedCanvas == null ? void 0 : croppedCanvas.toDataURL('image/jpeg', 0.7)) ?? null;
  }
  if (dataUrlType === SignatureFormat.POINTS) {
    const points = decodePoints(dataUrl);
    if (!points) {
      return null;
    }
    const blackPoints = points.map(pointGroup => ({
      ...pointGroup,
      penColor: 'black'
    }));
    // Width doesn't matter, it will be cropped later
    const canvas = createCanvas(MAX_HEIGHT * 20, MAX_HEIGHT, Math.max(window.devicePixelRatio || 1, 1));
    const signaturePad = new SignaturePad(canvas);
    signaturePad.fromData(blackPoints);
    const croppedCanvas = getCroppedCanvas(canvas);
    if (!croppedCanvas) {
      // Empty image case
      return null;
    }
    const scaledCanvas = getScaledCanvas(croppedCanvas, undefined, MAX_HEIGHT, 'white');
    return scaledCanvas.toDataURL('image/jpeg', 0.7);
  }
  if (dataUrlType != null && dataUrlType.startsWith('image/')) {
    const canvas = await createCanvasFromDataUrl(dataUrl);
    const croppedCanvas = getCroppedCanvas(canvas);
    if (!croppedCanvas) {
      // Empty image case
      return null;
    }
    const scaledCanvas = getScaledCanvas(croppedCanvas, undefined, MAX_HEIGHT);
    return scaledCanvas.toDataURL('image/jpeg', 0.7);
  }
  return dataUrl;
}
export async function convertToPNGFile(dataUrl, rtl) {
  const pngDataUrl = await dataUrlToPngDataUrl(dataUrl, rtl);
  if (!pngDataUrl) {
    return undefined;
  }
  return dataUrlToFile(pngDataUrl, 'signature');
}
//# sourceMappingURL=data-url.js.map